import Vue from 'vue';
import { pick as _pick } from 'lodash-es';
import { MUTATION } from './CONSTANTS';

export default {
  [MUTATION.SET_LOADING](state, loading) {
    Vue.set(state, 'loading', loading);
  },
  [MUTATION.SET_ERROR](state, error) {
    Vue.set(state, 'error', error);
  },
  [MUTATION.SET_DASHBOARD](state, newDashboard) {
    const currentDashboard = state.dashboard ?? { status_groups: [] };
    Vue.set(state, 'dashboard', {
      status_groups: [...currentDashboard.status_groups, ...newDashboard.status_groups],
    });
  },
  [MUTATION.SET_STATUS_GROUP](state, statusGroup) {
    const statusGroupIndex = state.dashboard.status_groups.findIndex(
      ({ name }) => name === statusGroup.name,
    );
    Vue.set(state.dashboard.status_groups, statusGroupIndex, statusGroup);
  },
  [MUTATION.UPDATE_STATUS_GROUP_DEAL](state, { dealIndex, dealData }) {
    const statusGroupIndex = state.dashboard.status_groups.findIndex(
      ({ name }) => name === dealData.status_group,
    );
    const dealDataForDashboard = _pick(dealData, [
      'uid',
      'status_group',
      'days_in_status_group',
      'status',
      'stage',
      'property',
      'primary_contact',
      'listing_status',
      'open_tasks_count',
      'open_status_prompts_count',
      'upcoming_appointments_count',
      'open_callback_requests_count',
    ]);
    Vue.set(state.dashboard.status_groups[statusGroupIndex].deals, dealIndex, dealDataForDashboard);
  },
  [MUTATION.SET_SELECTED_TAG](state, selectedTag) {
    Vue.set(state, 'selectedTag', selectedTag);
  },
  [MUTATION.SET_EXPANDED_DEAL_LOADING](state, loading) {
    Vue.set(state, 'expandedDealLoading', loading);
  },
  [MUTATION.SET_EXPANDED_DEAL](state, expandedDeal) {
    Vue.set(state, 'expandedDeal', expandedDeal);
  },
  [MUTATION.TOGGLE_CREATE_NOTE_MODAL_VISIBILITY](state, dealUid = null) {
    Vue.set(state, 'createNoteModal', {
      dealUid,
      isVisible: !state.createNoteModal.isVisible,
    });
  },
  [MUTATION.SET_NOTIFICATION](state, { message, type = 'success', autoClose = false }) {
    Vue.set(state, 'notification', {
      message,
      type, // success|error|warning|info|confirm
      autoClose,
    });
  },
  [MUTATION.UNSET_NOTIFICATION](state) {
    Vue.set(state, 'notification', {
      message: null,
      type: null,
      autoClose: false,
    });
  },
};
